import {
    GET_STYLEWISE_DETAIL_REPORT_REQUEST,
    GET_STYLEWISE_DETAIL_REPORT_SUCCESS,
    GET_STYLEWISE_DETAIL_REPORT_ERROR
} from "../actions/types";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const GetStyleWiseDetail = (token, data) => (dispatch) => {
    dispatch({ type: GET_STYLEWISE_DETAIL_REPORT_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}getAll/PODetailReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            reference_no: data.po,
            report_name: data.report,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_STYLEWISE_DETAIL_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_STYLEWISE_DETAIL_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_STYLEWISE_DETAIL_REPORT_ERROR,
                payload: error.response,
            });
        });
};
